document.addEventListener("DOMContentLoaded", function () {
  const uniqueIDInput = document.getElementById("uniqueIDInput");
  const submitButton = document.getElementById("submitUniqueID");
  const errorMessage = document.getElementById("errorMessage");

  // ✅ Check if elements exist before attaching event listeners
  if (!uniqueIDInput || !submitButton || !errorMessage) {
    console.error("❌ Missing elements on /custom page. Check HTML structure.");
    return;
  }

  submitButton.addEventListener("click", async () => {
    const uniqueID = uniqueIDInput.value.trim();
    if (!uniqueID) {
      alert("Please enter a Unique ID.");
      return;
    }

    try {
      // ✅ Send request to verify Unique ID
      const response = await fetch("https://vaultverification-2qscavuooa-uc.a.run.app/verify-id", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uniqueId: uniqueID }),
      });

      const data = await response.json();

      if (!data.success) {
        errorMessage.style.display = "block";
        return;
      }

      // ✅ Redirect to message update page
      window.location.href = `/pages/message-update?uid=${uniqueID}`;
    } catch (error) {
      console.error("❌ Error verifying Unique ID:", error);
      alert("An error occurred. Please try again.");
    }
  });
});

